import { NgModule } from '@angular/core';

import { Section05Component } from './section05.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    Section05Component
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    Section05Component
  ]
})

export class Section05Module { }
